export function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">© 2025 ProRata.ai. All rights reserved.</div>
          <div className="footer-links">
            <a
              href="https://prorata.ai/terms/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Terms of Service
            </a>
            <a
              href="https://prorata.ai/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
